import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dialog} from 'react-weui';
import axios from 'axios';
import {getTimestamp} from '../../utils'
import qs from 'qs'

class ClassroomCheckIn extends Component {
    state = {
        showErrorDialog: false,
        errorContent: '',
        styles: {
            buttons: [
                {
                    type: 'default',
                    label: '取消',
                    onClick: this.onHideDialog.bind(this)
                },
                {
                    type: 'primary',
                    label: '确定',
                    onClick: this.onConfirmDialog.bind(this)
                }
            ],
            errorButtons: [
                {
                    type: 'primary',
                    label: '确定',
                    onClick: this.onHideErrorDialog.bind(this)
                }
            ]
        }
    };

    render() {
        let {showCheckIn} = this.props;
        let {styles, showErrorDialog, errorContent} = this.state;
        return (
            <div>
                <Dialog buttons={styles.buttons} show={showCheckIn}>签到功能可以查看学员是否前来听课，是否发起签到活动？</Dialog>
                <Dialog buttons={styles.errorButtons} show={showErrorDialog}>{errorContent}</Dialog>
            </div>
        )
    }

    onHideDialog() {
        this.props.dispatch({
            type: 'CLASSROOM_HIDE_CHECK_IN'
        });
    }

    onHideErrorDialog() {
        this.setState({showErrorDialog: false});
    }

    onConfirmDialog() {
        this.props.dispatch({
            type: 'CLASSROOM_HIDE_CHECK_IN'
        });

        let {lecture} = this.props;
        let url = `/api/classroom/${lecture.id}/checkin/create`;

        const {timestampDelta} = this.props
        let timestamp = getTimestamp(timestampDelta)
        const data = {
            ts: timestamp
        }
        axios.post(url,  qs.stringify(data)).then((response) => {
            if (response.data.code !== 0) {
                this.setState({showErrorDialog: true, errorContent: response.data.msg});
            }
        });
    }
}

export default connect((state) => ({
    lecture: state.classroom.lecture,
    showCheckIn: state.classroom.showCheckIn,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomCheckIn)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomCheckIn.js